module.exports = __webpack_public_path__ + "img/naver_step2.e2d9b7b2.png";